// UKCompanyRegistration.jsx
import React from "react";

export default function UKCompanyRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            UK Company Registration 🇬🇧
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            UK Company Registration - Companies House Compliance
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists with UK Company Registration in
            compliance with Companies House regulations for private limited
            companies, enabling rapid incorporation with global market access.
          </p>
          <p className="text-gray-700">
            From Companies House WebFiling IN01 submission and name availability
            check to Certificate of Incorporation issuance, PSC register setup,
            and HMRC Corporation Tax registration, the process ensures legal
            entity status within 24 hours.
          </p>
        </div>

        {/* Right: UK Business Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100 bg-gradient-to-br from-gray-100 to-gray-200">
            <img
              src="https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?auto=format&fit=crop&w=1200&q=80"
              alt="London UK business district for Companies House registration"
              className="w-full aspect-square object-cover block"
              loading="eager"
              onError={(e) => {
                e.target.src = "https://images.pexels.com/photos/672532/pexels-photo-672532.jpeg?auto=compress&cs=tinysrgb&w=1200";
              }}
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for UK Company Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks coordinates complete documentation for
              Companies House approval and HMRC compliance setup.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Director and shareholder details (name, DOB, nationality, address, PSC status).</li>
                <li>UK registered office address (physical UK address for statutory mail).</li>
                <li>Identity proof (passport, driving license, or national ID verification).</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm provides specialized UK incorporation services with local
              compliance partnerships and Companies House expertise.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  UK Incorporation Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete knowledge of Companies House WebFiling, PSC register,
                  SIC codes, Model Articles adoption, and post-incorporation HMRC
                  requirements for seamless setup.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Quick and Compliant Setup
                </h3>
                <p className="text-gray-700 text-sm">
                  24-hour incorporation processing through Companies House
                  online portal with automatic Corporation Tax registration,
                  confirmation statement readiness, and compliance checklist.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Advisory Support
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end service from name reservation through Certificate
                  of Incorporation, business bank account setup, VAT/PAYE
                  registration, annual accounts filing, and ongoing Companies
                  House compliance.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
